import React from "react";
import { Form, Modal } from "antd";
import { InputText, PhotoUploader } from "../../../../components";
import { InputType } from "../../../../models";
import { isObject } from "../../../../services";

const imageField = "imageId";

// eslint-disable-next-line max-lines-per-function
const ShareLinkForm = ({ onSubmit, form, show, values }) => {
  const handleSubmit = () => {
    const value = form.getFieldsValue();
    let submitData = {};

    isObject(value) &&
      Object.keys(value).forEach(key => {
        if (key !== imageField) {
          submitData = { ...submitData, ...value[key] };
        } else if (value[key]) {
          submitData = { ...submitData, [key]: value[key][key][0] };
        }
      });

    onSubmit(Object.keys(submitData).length > 0 ? submitData : null);
    form.resetFields();
  };

  const getFormFieldData = field => {
    let initialValue;

    if (values[field]) {
      initialValue = {
        [field]: field === imageField ? [values[field]] : values[field]
      };
    }

    return [field, { initialValue }];
  };

  return (
    <Modal
      title={"Ažuriraj vezu za dijeljenje"}
      visible={show}
      onOk={handleSubmit}
      onCancel={() => {
        onSubmit();
      }}
      okText={"U redu"}
      cancelText={"Otkaži"}
    >
      <Form>
        <Form.Item>
          {form.getFieldDecorator(...getFormFieldData("header"))(
            <InputText
              title={"Naziv"}
              placeholder={"Naziv veze za dijeljenje"}
              field="header"
            />
          )}
        </Form.Item>
        <Form.Item>
          {form.getFieldDecorator(...getFormFieldData("description"))(
            <InputText
              title={"Opis"}
              placeholder={"Opis veze za dijeljenje"}
              field="description"
              valueType={InputType.text}
            />
          )}
        </Form.Item>
        <Form.Item>
          {form.getFieldDecorator(...getFormFieldData(imageField))(
            <PhotoUploader
              title={"Slika"}
              field={imageField}
              maxPhotoNumber={1}
            />
          )}
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default Form.create()(ShareLinkForm);



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageAdPage/ShareLinkForm/ShareLinkForm.tsx